import store from '@/store';
export default function guard(to, from, next) {
    // Retrieve information about verification from store
    // Check if user can pass pages requiring verification
    var predicate = store.getters['auth/verified'] == true;
    // If check returns true, user can proceed to page
    // Otherwise, user is redirected to the verify page
    return predicate ? next() : next({ name: 'verify' });
}
;
